// DEpendencies
import { FC, SyntheticEvent } from "react";

// Components
import { Tabs } from "@mui/material";

// utils
import { getMonthFromToDay } from "~/utils";

// Styles
import { StyledTab } from "./Month.styled";

interface MonthTabProps {
  currentMonth: {
    year: string | number;
    month: string | number;
  };
  onChangeMonth: (event: SyntheticEvent<Element, Event>, value: any) => void;
}

const months = getMonthFromToDay();

const MonthTab: FC<MonthTabProps> = ({ currentMonth, onChangeMonth }) => {
  return (
    <Tabs
      value={JSON.stringify(currentMonth)}
      onChange={onChangeMonth}
      variant={"scrollable"}
    >
      {months?.map(({ month, year }) => (
        <StyledTab
          label={`${month}/${year}`}
          value={JSON.stringify({ year, month })}
          key={`${month}/${year}`}
        />
      ))}
    </Tabs>
  );
};

export default MonthTab;
